if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer?.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.bindThumbnailEvents();
        if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      bindThumbnailEvents() {
        if (!this.elements.thumbnails) return;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            ?.addEventListener('click', (e) => {
              e.preventDefault();
              this.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
        });
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails || !event.detail?.currentElement) return;
        const targetId = event.detail.currentElement.dataset.mediaId;
        const thumbnail =
          this.elements.thumbnails.querySelector(`[data-target="${targetId}"]`) ||
          this.elements.thumbnails.querySelector(`[data-target$="-${targetId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        let activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector(`[data-media-id$="-${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement && activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`) ||
              this.elements.thumbnails.querySelector(`[data-target$="-${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.resetPages) this.elements.viewer.resetPages();
          if (this.elements.thumbnails?.resetPages) this.elements.thumbnails.resetPages();
        }

        this.preventStickyHeader();

        // Scroll viewer slider to the active media item
        const viewerSlider = this.elements.viewer.querySelector('.slider') || this.elements.viewer.slider || activeMedia.parentElement;
        if (viewerSlider) {
          if (prepend) {
            viewerSlider.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            viewerSlider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
          }
        }

        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail =
            this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`) ||
            this.elements.thumbnails.querySelector(`[data-target$="-${mediaId}"]`);
          if (activeThumbnail) {
            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');

        const thumbSlider = this.elements.thumbnails.querySelector('.slider') || this.elements.thumbnails.slider;
        if (thumbSlider) {
          thumbSlider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          if (this.elements.liveRegion) {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = (window.accessibilityStrings?.imageAvailable || 'Image [index]').replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          }
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
